import { call } from "redux-saga/effects";

import { API_ENDPOINTS } from "../../constants/api";
import { apiGet, apiPost } from "../../utils/apiClient";
import { DOMAIN_ERROR_CODES, DomainError } from "../../utils/errors";
import { Company, CompetitorsResponse } from "../auth/types";
import { LogoDescribeResponse } from "../brands/types";

import { applySagaError } from "./applySagaError";

export function* reserchScoresSaga(
  userId: string,
  init_prompts: boolean,
  prompts?: number[],
  competitor_id?: string,
  brand_id?: number,
) {
  try {
    if (!userId) {
      throw new DomainError(
        DOMAIN_ERROR_CODES.VALIDATION_FAILED,
        "User ID is required",
      );
    }

    yield call(apiPost<Response>, API_ENDPOINTS.scores, {
      auth: "tokenApi",
      body: {
        user_id: userId,
        ...(init_prompts && { init_prompts: true }),
        ...(prompts && { prompts: prompts }),
        ...(competitor_id && { new_competitor_id: competitor_id }),
        ...(brand_id && { brand_id: brand_id }),
      },
    });
  } catch (error) {
    yield* applySagaError(error, {
      operationName: "scores.researchScores",
      notifyUser: false,
    });
  }
}

export function* fetchCompetitorsSaga(brand: Company) {
  try {
    let dataDescribe: LogoDescribeResponse | null = null;

    if (brand.website) {
      const dataDescribeResponse: LogoDescribeResponse = yield call(
        apiGet<LogoDescribeResponse>,
        API_ENDPOINTS.logoDescribe(brand.website),
        {
          auth: "logoApi",
        },
      );
      dataDescribe = dataDescribeResponse;
    }

    const data: CompetitorsResponse = yield call(
      apiPost<CompetitorsResponse>,
      API_ENDPOINTS.competitors,
      {
        auth: "tokenApi",
        body: {
          brand_name: brand.name,
          description: dataDescribe ? dataDescribe.description : "",
        },
      },
    );

    return data;
  } catch (error) {
    yield* applySagaError(error, {
      operationName: "utils.fetchCompetitors",
    });
    throw error;
  }
}
